import { differenceInYears } from 'date-fns';

export const isUnder18 = (date: Date) => differenceInYears(new Date(), date) < 18;
